import { registerBlockType } from '@wordpress/blocks';
import metadata from './block.json';
import Edit from './edit';
import Save from './save';
import deprecated from './deprecated';

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  deprecated,
  icon: {
    foreground: '#0061FE',
    src: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24"
        height="24"
        fill="currentColor"
      >
        {/* Card outline */}
        <path d="M4 2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm0 2v16h16V4H4z" />
        {/* Icon disc */}
        <circle cx="12" cy="8.5" r="2.5" />
        {/* Two lines of text */}
        <rect x="6" y="13.5" width="12" height="1.8" rx="0.9" />
        <rect x="8" y="17" width="8" height="1.8" rx="0.9" />
      </svg>
    ),
  },
});
